// Skills Icons
import htmlIcon from "./images/html.svg"
import cssIcon from "./images/css.svg"
import reactIcon from "./images/react.svg"
import jsIcon from "./images/javascript.svg"
import designIcon from "./images/design.svg"
import codeIcon from "./images/code.svg"

// Social Icon
import githubIcon from "./images/github.svg"
import codepenIcon from "./images/codepen.svg"
import dribbbleIcon from "./images/dribbble.svg"
import instagramIcon from "./images/instagram.svg"

export default {
  //(Please Do Not Remove The comma(,) after every variable)
  //Change The Website Template

  //   Header Details ---------------------
  name: "Muhammad Ali Khan",
  headerTagline: [
    //Line 1 For Header
    "Beautiful",
    //Line 2 For Header
    "creative solutions",
    //Line 3 For Header
    "for websites",
  ],
  //   Header Paragraph
  headerParagraph:
    "Contact me for project discussion",

  //Contact Email
  contactEmail: "alikhan1996116@gmail.com",

  // End Header Details -----------------------

  // Work Section ------------------------
  projects: [
    {
      title: "https://food-book.co/", //Project Title - Add Your Project Title Here
      para:
        "Checkout this project I worked on", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://i.ibb.co/PMn2kRP/foodimage.jpg",
      //Project URL - Add Your Project Url Here
      url: "https://food-book.co/",
    },
    {
      title: "https://feedu.co.il/", //Project Title - Add Your Project Title Here
      para:
        "Checkout this project I worked in", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://i.ibb.co/86pNFgR/development.jpg",
      //Project URL - Add Your Project Url Here
      url: "https://feedu.co.il/",
    },
    {
      title: "https://heretofeedu.com/", //Project Title - Add Your Project Title Here
      para:
        "Checkout this project I worked on", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://i.ibb.co/YpbvB6H/food2.jpg",
      //Project URL - Add Your Project Url Here
      url: "https://heretofeedu.com/",
    },
    {
      title: "Admin Dashboard", //Project Title - Add Your Project Title Here
      para:
        "Private Client info", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc:
        "https://i.ibb.co/6WLxq71/dashb.png",
      //Project URL - Add Your Project Url Here
      url: "http://localhost:8000",
    },

    /*
    If You Want To Add More Project just Copy and Paste This At The End
    ,{
        title: 'Project Five',
        para: 'Something Amazing',
        imageSrc: "",
        url: ''
    }
    */
  ],

  // End Work Section -----------------------

  // About Secton --------------
  aboutParaOne:
    "I am a Full Stack Web Developer. To be specific,I am MERN(MongoDB, Express js, React js, Node js) Stack Developer.",
  aboutParaTwo:
    "I have worked on XD/Figma to responsive and flexible webiste designs, locations, payment methods(paypal, metamask), text editors, translations, backend REST apis, twilio sms integration, multer, typescript, redux and much more",
  aboutParaThree:
    "I strive to provide quality work to completely satisfy the needs of my clients. In case of any queries, contact me and we would go from there.",
  aboutImage:
    "https://i.ibb.co/T46nS9d/mypicture.jpg",
  //   End About Section ---------------------

  // Skills Section ---------------

  //   Import Icons from the top and link it here

  skills: [
    {
      img: reactIcon,
      para:
        "React",
    },
    {
      img: codeIcon,
      para:
        "Node",
    },
    {
      img: "https://i.ibb.co/59xxxC6/database-Icon.png",
      para:
        "Mongodb",
    },
    {
      img: htmlIcon,
      para:
        "HTML",
    },
    {
      img: cssIcon,
      para:
        "CSS",
    },
    {
      img: jsIcon,
      para:
        "Javascript",
    },
  ],

  // End Skills Section --------------------------

  //   Promotion Section --------------------------

  promotionPara:
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  // End Promotion Section -----------------

  //   Contact Section --------------

  contactSubHeading: "Let's create your next experience together",
  social: [
    // Add Or Remove The Link Accordingly
    { img: githubIcon, url: "https://github.com/mak9606?tab=repositories" },
    // {
    //   img: codepenIcon,
    //   url: "https://www.codepen.com/",
    // },
    // {
    //   img: dribbbleIcon,
    //   url: "https://dribbble.com/chetanverma",
    // },
    {
      img: instagramIcon,
      url: "https://www.instagram.com/",
    },
  ],

  // End Contact Section ---------------
}

// Thanks for using this template, I would love to hear from you contact me at hello@chetanverma.com
